(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {

		// Get footer logo.
		var footerLogo = $('#footer-logo');

		// If we don't have a footer logo.
		if(!footerLogo.length) {

			// Exit.
			return;
		}

		//
		if(typeof window.IntersectionObserver === "undefined") {

			//
			footerLogo.removeClass("invisable").addClass("animated fadeIn slow");

			//
			return;
		}

		// Create a scroll observer.
		var fadeInObserver = new IntersectionObserver(function(entries, observer) {

			// Loop over entries.
			entries.forEach(function(entry) {

				// If footer logo is in view.
				if(entry.intersectionRatio > 0) {

					// Remove invisable class, and add animation classes.
					footerLogo.removeClass("invisable").addClass("animated fadeIn slow");

					// Stop observe footer logo.
					observer.unobserve(entry.target);
				}
			});
		});

		// Start to observe footer logo.
		fadeInObserver.observe(footerLogo[0]);

	});

})(window.jQuery);
